/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".collapse-btn-style[_ngcontent-%COMP%]{font-size:20em}.main-app-header[_ngcontent-%COMP%]{background:linear-gradient(140deg,#75e79c 0,#6dd891 100%);color:#fff}.sub-header-bg[_ngcontent-%COMP%]{background:linear-gradient(140deg,#41a9fb 0,#2c95fb 100%)}"];
export { styles as styles };
